<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <el-page-header v-if="backShow" @back="goBack"></el-page-header>
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span v-if="item.redirect === 'noRedirect' || index == levelList.length - 1" class="no-redirect">{{
          item.meta.title
        }}</span>
        <!-- <span v-else-if="backShow" class="call-back-btn" title="返回" @click="$router.go(-1)">返回</span>      -->
        <a v-else @click.prevent="handleLink(item)">{{ item.meta.title }}</a>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  data() {
    return {
      levelList: null,
      backShow: false
    }
  },
  watch: {
    $route(route) {
      // if you go to the redirect page, do not update the breadcrumbs
      if (route.path.startsWith('/redirect/')) {
        return
      }
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    getBreadcrumb() {
      // only show routes with meta.title
      if (this.$route.meta.backShow && this.$route.meta.backShow == true) {
        this.backShow = true
      } else {
        this.backShow = false
      }
      let matched = this.$route.matched.filter((item) => item.meta && item.meta.title)
      // if (this.backShow) {
      //   matched = [{ path: '/details', meta: { title: '返回' }}].concat(matched)
      // }
      // const first = matched[0]
      // if (!this.isDashboard(first)) {
      //   matched = [{ path: '/index', meta: { title: '首页' }}].concat(matched)
      // }
      this.levelList = matched.filter((item) => item.meta && item.meta.title && item.meta.breadcrumb !== false)
    },
    isDashboard(route) {
      const name = route && route.name
      if (!name) {
        return false
      }
      return name.trim() === 'Index'
    },
    handleLink(item) {
      const { redirect, path } = item
      if (redirect) {
        this.$router.push(redirect)
        return
      }
      this.$router.push(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb {
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  width: 100%;
  background: #f7f8fa;
  // border-bottom: 1px solid #d8dce5;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
  display: inline-block;
  padding-left: 15px;

  .no-redirect {
    color: #666666;
    cursor: text;
  }
}

.breadcrumb {
  height: 24px;
  width: 100%;
  background-color: #f7f8fa;
}

::v-deep .el-page-header {
  float: left;
  line-height: 40px;
}

::v-deep .el-page-header__left {
  color: #0b0b0b;
}
</style>
